import { getContext, call } from 'redux-saga/effects';

export const getAppCraftStore = () => getContext('appCraftStore');
export const setGlobalContext = (context) =>
  call(function* _setGlobalContext() {
    const set = yield getContext('setGlobalContext');
    yield set(context);
  });
